import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';

import type {ModelHubRoute} from './modelHubRoutes';

export function setModelHubRoute(route: ModelHubRoute): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.MODEL_HUB_SET_ROUTE,
    route,
  });
}

/**
 * Clears the stored route, marking the screen as having been entered via the legacy `/model-hub`
 * URL. The store is a session-long singleton, so the legacy route handler must clear explicitly
 * rather than rely on a route never having been set.
 */
export function clearModelHubRoute(): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.MODEL_HUB_CLEAR_ROUTE,
  });
}
